module.exports = __webpack_public_path__ + "assets/icons/baseline-person_add-24px-7783.svg";